import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";

function SphereShortestPath() {
  const mapRef = useRef(null);
  const [drawLocation, setDrawLocation] = useState([]);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const data = queryParams.get("data");

  useEffect(() => {
    const storedData = sessionStorage.getItem("geoJsonData");
    let parsedData;

    if (storedData) {
      // Parse it back to an object if needed
      parsedData = JSON.parse(storedData);

      // Use the data
      console.log(parsedData);
      // You can now work with parsedData, e.g., display it or manipulate it.
    }
    const script = document.createElement("script");
    let map;
    script.src =
      "https://api.sphere.gistda.or.th/map/?key=8B4398A1CDEC4BA695CB6D083534F359";
    script.async = true;
    script.onload = () => {
      map = new window.sphere.Map({
        placeholder: mapRef.current,
      });

      map.Event.bind("ready", function (location) {
        console.log("Map is Ready");

        // Hide the default toolbar if needed
        map.Ui.Toolbar.visible(false);

        // Load the necessary styles and scripts for Mapbox Draw
        window.sphere.Util.loadStyle(
          window.sphere.Server.map + "/js/mapbox-gl-draw.css"
        );
        window.sphere.Util.loadScript(
          window.sphere.Server.map + "/js/mapbox-gl-draw.js",
          () => {
            // Define the options for the Mapbox Draw tool
            const drawOptions = {
              controls: {
                point: false,
                line_string: true,
                polygon: true,
                trash: true,
                combine_features: false,
                uncombine_features: false,
              },
            };

            // Initialize the Mapbox Draw tool
            var drawPanel = new window.MapboxDraw(drawOptions);

            // Add the draw tool to the map
            map.Renderer.addControl(drawPanel, "top-right");

            // Listen for draw events directly on the drawPanel instance
            map.Renderer.on("draw.create", (event) => {
              console.log(
                "Feature created:",
                event.features[0].geometry.coordinates[0]
              );
              setDrawLocation(event.features[0].geometry.coordinates[0]);
            });
            map.Renderer.on("draw.update", (event) => {
              console.log(
                "Feature updated:",
                event.features[0].geometry.coordinates[0]
              );
              setDrawLocation(event.features[0].geometry.coordinates[0]);
            });

            map.Renderer.on("draw.delete", (event) => {
              console.log("Feature deleted:", event.features);
              // event.deleteAll()
            });
          }
        );

        const polygon_line = new window.sphere.Polyline(parsedData[0], {
          lineWidth: 4,
          lineColor: 'rgba(0, 153, 51, 1.0)',
        });
        map.Overlays.add(polygon_line);

        const polygon_path = new window.sphere.Polygon(parsedData[1], {
          lineWidth: 2,
          lineColor: "rgba(0, 150, 70, 1)",
          fillColor: "rgba(60, 179, 113, 0.5)",
        });
        map.Overlays.add(polygon_path);

        const building_not_intersect_polygon = new window.sphere.Polygon(
          parsedData[3],
          {
            lineWidth: 2,
            lineColor: "rgba(0, 0, 255, 0.3)",
            fillColor: "rgba(75, 150, 255, 0.5)",
          }
        );
        map.Overlays.add(building_not_intersect_polygon);

        const building_intersect_polygon = new window.sphere.Polygon(
          parsedData[2],
          {
            lineWidth: 2,
            lineColor: "rgba(140, 0, 0, 1)",
            fillColor: "rgba(255, 20, 70, 0.5)",
          }
        );
        map.Overlays.add(building_intersect_polygon);
      });

      // const polygon = [];

      // map.Event.bind(window.sphere.EventName.Click, function (location) {

      //   setMouseLocation([location.lat, location.lon]);
      //   const coordinate = { lat: 0, lon: 0 };
      //   coordinate.lat = location.lat;
      //   coordinate.lon = location.lon;
      //   if (polygon.length === 0) {
      //     polygon.push(coordinate);
      //   }
      // });
    };
    document.body.appendChild(script);
  }, []);

  return (
    <div>
      {/* <h1>SPHERE MAP</h1>
      <p>
        {drawLocation.join('')}
      </p> */}
      <div id="map" ref={mapRef} style={{ height: "100vh" }}></div>
    </div>
  );
}

export default SphereShortestPath;
